import { putUserCart } from 'api/cart'
import debounce from 'lodash.debounce'
export const saveUserCartDebounced = debounce(saveUserCart, 300)

function saveUserCart(userCartState: App.UserCartState) {
  putUserCart(userCartState).catch(err => console.error(err))
}
